import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';


export const MEDIA = {
    tablet: 'max-width: 1279px',
    mobile: 'max-width: 639px',
};

export const Container = styled.div`
    display: block;
`;

export const Header = styled.b`
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 14px;
    display: block;
`;

export const Link = styled.a`
    font-size: 14px;
    line-height: 24px;
    color: ${COLORS.darkGrey};
    transition: 0.25s;
    cursor: pointer;

    &:hover {
        color: #000;
    }
`;

export const LinkWithIcon = styled.a`
    font-size: 14px;
    line-height: 24px;
    color: ${COLORS.blue};
    transition: 0.25s;
    cursor: pointer;
    display: flex;
    align-items: center;

    & > svg {
        margin-right: 8px;
        fill: currentColor;
        transition: 0.25s;
    }

    &:hover {
        color: #ed1c24
    }
`;

export const RowNav = styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-bottom: 38px;
    grid-gap: 16px;

    @media(${MEDIA.tablet}) {
        justify-content: flex-start;
        grid-gap: 13%;
    }

    @media(${MEDIA.mobile}) {
        display: block;
        margin-top: 16px;

        & > *:nth-child(1) {
            margin-bottom: 14px;
        }
    
        & > *:nth-child(2) {
        }
    }
`;

export const RowCallback = styled.div`
    display: flex;
    align-items: baseline;
    margin-bottom: 54px;

    & > *:first-child {
        margin-right: 32px;
        margin-bottom: 8px;
    }
`;

export const List = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    grid-gap: 14px;
`;

export const ListItem = styled.li`
    display: block;
`;

export const ItemLink = styled.a`
    font-size: 14px;
    line-height: 24px;
    color: ${COLORS.darkGrey};
    transition: 0.25s;
    cursor: pointer;

    &:hover {
        color: #000;
    }
`;

const mixinlinkStyle = () => `
    padding: 2px 0;
    font-size: 14px;
    line-height: 1.25;
    color: #1e81d6;
    transition: 0.25s;
    cursor: pointer;
    &:hover {
        color: #ed1c24;
        transition: 0.25s;
    }
`;

export const LinkText = styled.div`
    ${mixinlinkStyle()}
`;
